import { Messages } from '../../codegen/Localize';
import { IRemoteRefreshPropertiesInfo } from '../../extractRefresh/models/IRemoteRefreshPropertiesInfo';

export module RemoteQueryAgentHelper {

  // Determine the correct display name given how this data source is or isn't assigned to a remote query agent
  export function getRemoteQueryAgentDisplayName(refreshPropertiesInfo: IRemoteRefreshPropertiesInfo): string {

    if (!refreshPropertiesInfo) {
      // Unexpected case, but show something here anyway.
      return Messages.notApplicable();

    } else if (refreshPropertiesInfo.remoteAgentName) {
      if (refreshPropertiesInfo.remoteQueryAgentSiteDefault) {
        // Site default.
        return Messages.datasourceRemoteQueryAgentIsSiteDefault({
          AGENT_NAME: refreshPropertiesInfo.remoteAgentName
        });
      } else {
        // Directly assigned.
        return refreshPropertiesInfo.remoteAgentName;
      }

    } else {
      // Site default, but no agent has been designated as the default.
      return Messages.datasourceRemoteQueryAgentSiteDefaultNoneOption();
    }
  }
}
